import React, { useState, useEffect, memo, useMemo } from "react";
import Header from "../../layout/Header";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
// eslint-disable-next-line
import { decrypt } from "../../../utils/encodingdecoding";
import { getSchemaList } from "../../../services/auth"
import Paginated2 from "./Pagination2";
import { getUserTypeOptions, sobiscoMerchantId } from "../../../utils";
import { getAllCustomer } from "../../../services/services";

const UserDetails = memo(() => {
    const [data, setData] = useState([]);
    const [response, setResponse] = useState([]);
    const [schemaData, setSchemaData] = useState()
    const [loader, setLoader] = useState(false);
    const [searchParams] = useSearchParams();
    const customerType = searchParams.get("type");
    const [selectedUserType, setSelectedUserType] = useState(customerType ? customerType : "");
    const [selectedUserNumber, setSelectedUserNumber] = useState("");
    const [searchValue, setSearchValue] = useState("")
    const [initialLoad, setInitialLoad] = useState(false)
    const id = decrypt(localStorage.getItem("Id"))

    useEffect(() => {
        if (response) {
            const mappedData = response?.map((val) => {
                const modifiedCustomerData = {
                    ...val,
                    cpcustomertype:
                        val?.cpcustomertype === "CustomerCP"
                            ? "Customer"
                            : val?.cpcustomertype,
                };
                const updatedVal = {
                    ...val,
                    action: val.customercode,
                    customerType: val.customerType,
                    customerData: modifiedCustomerData,
                };

                if (schemaData) {
                    Object.keys(schemaData).forEach((key) => {
                        if (schemaData[key].isFormView) {
                            updatedVal[key] = modifiedCustomerData[key] || "";
                        }
                    });
                }

                return updatedVal;
            });
            setData(mappedData);
        } else {
            setData([]);
        }
    }, [response, schemaData]);

    const fetch = async () => {
        try {
            setLoader(true)
            const token = JSON.parse(localStorage.getItem("token_gen"));
            if (!schemaData) {
                const schemaRes = await getSchemaList(token?.access_token)
                setSchemaData(schemaRes?.schema?.properties)
            }
        } catch (err) {
            console.log(err)
        } finally {
        }

    };

    const dynamicColumns = useMemo(() => {
        if (!schemaData) return [];

        return Object.entries(schemaData)
            .filter(([key, item]) => {
                if (!item.isFormView) return false;

                if (selectedUserType === "") return true;

                const temp = getUserTypeOptions(id).filter(
                    (obj) => obj.value === selectedUserType
                );

                const selectedType = temp?.[0]?.customerType;

                if (item.customerType) {
                    return item.customerType
                        .toUpperCase()
                        .includes(selectedType?.toUpperCase());
                }

                return true;
            })
            .map(([key, value]) => (
                key === "cpcustomertype"
                    ? {
                        Header: "Customer Type",
                        Footer: "Customer Type",
                        accessor: key,
                    }
                    : key === "cpkycstatus"
                        ? {
                            Header: "KYC Status",
                            Footer: "KYC Status",
                            accessor: key,
                        }
                        : {
                            Header: value.fielddisplayname || value.label || key,
                            Footer: value.fielddisplayname || value.label || key,
                            accessor: key,
                        }
            ));
    }, [schemaData, selectedUserType]);

    const columns = useMemo(() => {
        const baseColumns = [...dynamicColumns];

        if (selectedUserType === "all") {
            baseColumns.splice(1, 0, {
                Header: "User Type",
                Footer: "User Type",
                accessor: "customerType",
                Cell: ({ value }) => value || "",
            });
        }
        const staticColumns = id === sobiscoMerchantId ? [
            ...baseColumns,
            {
                Header: "Action",
                Footer: "Action",
                accessor: "action",
                Cell: ({ value }) => (
                    <Link
                        to={`/user-view/${value}`}
                        state={{ customerCode: value, schemaData: schemaData }}

                    >
                        <i className="fa-solid fa-eye"></i> View Details
                    </Link >
                ),
            },
        ] : [
            ...dynamicColumns,
            {
                Header: "Earned Value",
                Footer: "Earned Value",
                accessor: "earnedValue",
            },
            {
                Header: "Available Value",
                Footer: "Available Value",
                accessor: "availableValue",
            },
            {
                Header: "Redeem Value",
                Footer: "Redeem Value",
                accessor: "redeemValue",
            },

            {
                Header: "Action",
                Footer: "Action",
                accessor: "action",
                Cell: ({ value }) => (
                    <Link
                        to={`/user-view/${value}`}
                        state={{ customerCode: value, schemaData: schemaData }}

                    >
                        <i className="fa-solid fa-eye"></i> View Details
                    </Link >
                ),
            },
        ];
        return staticColumns;
    }, [dynamicColumns, selectedUserType]);


    const generateCSV = async () => {
        setLoader(true);

        try {
            const token = JSON.parse(localStorage.getItem("token_gen"));

            if (!token?.access_token || !id) {
                throw new Error("Missing token or ID");
            }

            const res = await getAllCustomer(
                token?.access_token,
                "customer",
                true,
                "Customers",
                selectedUserNumber,
                searchValue,
                "customerType",
                selectedUserType,
                1,
                1000
            );

            if (res.message === "Success") {

                const filteredColumns = columns.filter(col => col.accessor !== "action");
                const csvHeaders = filteredColumns.map(col => col.Header);
                const csvRows = res?.data?.map(row =>
                    filteredColumns.map(col => {
                        const value = row[col.accessor];

                        return `"${value ?? ""}"`;
                    })
                );

                const csvData = [csvHeaders, ...csvRows];
                const csvContent =
                    "data:text/csv;charset=utf-8," +
                    csvData.map(row => row.join(",")).join("\n");

                const encodedUri = encodeURI(csvContent);
                const link = document.createElement("a");

                link.setAttribute("href", encodedUri);
                link.setAttribute("download", "customer-report.csv");

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

        } catch (error) {
            console.error("Error generating CSV:", error.message || error);
        } finally {
            setLoader(false);
        }
    };

    return (
        <>
            <Header name={"User Management"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>User List</h4>
                            </div>
                            <div className="dashboard__right">
                                <button onClick={() => generateCSV()} className="btn btn-default" disabled={searchValue?.length !== 10 || !selectedUserNumber || !selectedUserType}>
                                    <i
                                        class="fa-solid fa-download"
                                        style={{ marginRight: "10px" }}
                                    ></i>
                                    Download
                                </button>
                            </div>
                        </div>
                        <div className="dashboard__body">
                            <Paginated2
                                data={data}
                                tableColumns={columns}
                                loader={loader}
                                setLoader={setLoader}
                                selectedUserType={selectedUserType}
                                setSelectedUserType={setSelectedUserType}
                                setSelectedUserNumber={setSelectedUserNumber}
                                selectedUserNumber={selectedUserNumber}
                                setData={setData}
                                setResponse={setResponse}
                                fetchSchema={fetch}
                                setSearchValue={setSearchValue}
                                searchValue={searchValue}
                                initialLoad={initialLoad}
                                setInitialLoad={setInitialLoad}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default UserDetails
